import { tosApi } from './tosApi';

export type ExportRegistersType =
  | 'companies'
  | 'cargos'
  | 'cargo_types'
  | 'product_groups'
  | 'vessels'
  | 'tugboats'
  | 'pilots'
  | 'berths'
  | 'ports'
  | 'terminals';

export type ExportReportsType =
  | 'dockings'
  | 'operations'
  | 'breakdowns'
  | 'vessels-movement'
  | 'cargo-suppressions';

export type ExportRegistersQueryParamsType = {
  search?: string;
  company_type?: string;
};

export type ExportReportsQueryParamsType = {
  search?: string;
  initial_date?: string;
  final_date?: string;
};

export type ExportRegistersRequestType = {
  exportType: ExportRegistersType;
  params?: ExportRegistersQueryParamsType;
};

export type ExportReportsRequestType = {
  exportType: ExportReportsType;
  params?: ExportReportsQueryParamsType;
};

export const exportApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    exportRegisters: build.query<void, ExportRegistersRequestType>({
      query: ({ exportType, params }) => ({
        url: `/core/export/registers/${exportType}`,
        method: 'GET',
        params: params || {},
        cache: 'no-cache',
      }),
    }),
    exportReports: build.query<void, ExportReportsRequestType>({
      query: ({ exportType, params }) => ({
        url: `/core/export/reports/${exportType}`,
        method: 'GET',
        params: params || {},
        cache: 'no-cache',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useLazyExportRegistersQuery, useLazyExportReportsQuery } =
  exportApi;
